import { graphql } from 'react-relay';

export const bznavRefundUserPhone = graphql`
  query bznavRefundUserPhoneQuery {
    bznavRefund {
      user {
        phone
      }
    }
  }
`;

export const getDeligationInfoOfUser = graphql`
  query bznavRefundGetDeligationInfoOfUserQuery($refundId: String!) {
    getDeligationInfoOfUser(refundId: $refundId) {
      result
      name
      address
      birthDate
    }
  }
`;
